/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { configureEventCategoriesActions } from './slice';
import API from './constants';
/**
 * Event category configuration generator function to get major event categories
 * @param {*} param0
 */
export function* eventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.configureEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.configureEventCategoriesFailed(error?.message));
  }
}
/**
 * Add minor event category configuration generator function to add minor event categories
 * @param {*} param0
 */
export function* addMinorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.ADD_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.addMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.addMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Add major event category configuration generator function to add major event categories
 * @param {*} param0
 */
export function* addMajorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.ADD_MAJOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.addMajorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.addMajorEventCategoriesFailed(error?.message));
  }
}
/**
 * Get Minor event category configuration generator function to get minor event categories
 * @param {*} param0
 */
export function* getMinorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.getMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.getMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Update minor event categories configuration generator function to update multiple minor event categories
 * @param {*} param0
 */
export function* updateMinorEventCategoriesConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.UPDATE_MINOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.updateMinorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.updateMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Delete minor event category configuration generator function to delete minor event categories
 * @param {*} param0
 */
export function* deleteMinorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.DELETE_MINOR_EVENT_CATEGORIES, payload);
    yield put(
      configureEventCategoriesActions.deleteMinorEventCategoriesSucceeded({
        response,
        data: payload,
      })
    );
  } catch (error) {
    yield put(configureEventCategoriesActions.deleteMinorEventCategoriesFailed(error?.message));
  }
}
/**
 * Update major event categories configuration generator function to update major event categories
 * @param {*} param0
 */
export function* updateMajorEventCategoriesConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.UPDATE_MAJOR_EVENT_CATEGORIES, payload);
    yield put(configureEventCategoriesActions.updateMajorEventCategoriesSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.updateMajorEventCategoriesFailed(error?.message));
  }
}
/**
 * Delete major event category configuration generator function to delete major event categories
 * @param {*} param0
 */
export function* deleteMajorEventCategoryConfigurationGenerator({ payload }) {
  try {
    const response = yield call(request, API.DELETE_MAJOR_EVENT_CATEGORIES, payload);
    yield put(
      configureEventCategoriesActions.deleteMajorEventCategoriesSucceeded({
        response,
        data: payload,
      })
    );
  } catch (error) {
    yield put(configureEventCategoriesActions.deleteMajorEventCategoriesFailed(error?.message));
  }
}
//
export function* getHotelsSelectionListGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_HOTELS, payload);
    yield put(configureEventCategoriesActions.getSelectionHotelsListSucceeded(response));
  } catch (error) {
    yield put(configureEventCategoriesActions.getSelectionHotelsListFailed(error?.message));
  }
}
//
export function* eventCategoryConfigurationSaga() {
  yield takeLatest(
    configureEventCategoriesActions.configureEventCategories.type,
    eventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.addMinorEventCategories.type,
    addMinorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.addMajorEventCategories.type,
    addMajorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.getMinorEventCategories.type,
    getMinorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.updateMinorEventCategories.type,
    updateMinorEventCategoriesConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.deleteMinorEventCategories.type,
    deleteMinorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.updateMajorEventCategories.type,
    updateMajorEventCategoriesConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.deleteMajorEventCategories.type,
    deleteMajorEventCategoryConfigurationGenerator
  );
  yield takeLatest(
    configureEventCategoriesActions.getSelectionHotelsList.type,
    getHotelsSelectionListGenerator
  );
}
//
export default eventCategoryConfigurationSaga;
